export const isBrowser = () => {
    return typeof window !== 'undefined';
};
export const isPrerenderCrawler = (userAgent) => {
    return /Prerender/i.test(userAgent) || false;
};
//# sourceMappingURL=browser.js.map